/* eslint-disable react/require-default-props */
/* eslint-disable react/prop-types */
import {
	Button,
	Collapse,
	Divider,
	Fade,
	Stack,
	Typography
} from '@mui/material';
import SelectableCard from 'components/SelectableCard/SelectableCard';
import DisabledModeTooltip from 'components/shared/DisabeldModeToolTip';
import IdPIcon from 'components/shared/IdPIcon';
import { Method } from 'consts';
import React, { forwardRef } from 'react';
import { IIdP } from 'types/api';
import { TOnClick } from 'types/props';

interface IIdpCardProps {
	idp: IIdP;
	selected?: boolean;
	selectedMethod?: Method | null;
	onClick?: TOnClick;
	onMethodClick?: (method: Method) => any;
	showMethods?: boolean;
	disabled?: boolean;
}

const CARD_HEIGHT = 112;
const CARD_WIDTH = 250;
const CARD_PX = 2;

const IdpCard = forwardRef<HTMLDivElement, IIdpCardProps>(
	(
		{
			idp,
			selectedMethod = null,
			selected = false,
			onClick = undefined,
			onMethodClick = undefined,
			showMethods = false,
			disabled = false
		},
		ref
	) => (
		<DisabledModeTooltip
			disabled={!selected && disabled}
			title={intl.tr('general.guide.disabledTooltip')}
		>
			<SelectableCard
				ref={ref}
				data-testid="idp-gallery-card"
				data-selected={selected}
				sx={{ width: CARD_WIDTH, height: CARD_HEIGHT }}
				onClick={onClick}
				disabled={!selected && disabled}
				selected={selected}
			>
				<Stack height="100%">
					<Stack px={CARD_PX} direction="row" alignItems="center" flexGrow={1}>
						<Stack direction="row" alignItems="center" gap={1}>
							<IdPIcon idp={idp} />
							<Typography variant="body1">{idp.name}</Typography>
						</Stack>
					</Stack>
					<Fade
						in={showMethods}
						style={{ transitionDelay: showMethods ? '150ms' : '0ms' }}
					>
						<Divider variant="fullWidth" />
					</Fade>
					<Collapse in={showMethods} unmountOnExit timeout={200}>
						<Stack
							direction="row"
							px={2}
							alignItems="center"
							justifyContent="flex-end"
							height={52}
							gap={1}
						>
							{idp.methods.map((method) => (
								<Button
									key={method}
									data-testid={`${method}-method-button`}
									data-selected={selected && selectedMethod === method}
									size="small"
									variant={
										selected && selectedMethod === method
											? 'contained'
											: 'outlined'
									}
									onClick={() => {
										onMethodClick?.(method);
									}}
								>
									{intl.tr('general.methodUpper', {
										method
									})}
								</Button>
							))}
						</Stack>
					</Collapse>
				</Stack>
			</SelectableCard>
		</DisabledModeTooltip>
	)
);

export default IdpCard;
export { CARD_HEIGHT, CARD_PX, CARD_WIDTH };
